/**
 * ArchiveIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ArchiveIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M20.45 2h-17C2.1 2 1 3.1 1 4.45v2c0 .81.4 1.52 1 1.97v10.53c0 .78.31 1.53.86 2.09.55.55 1.3.86 2.09.86h14c.78 0 1.53-.31 2.09-.86s.86-1.3.86-2.09V8.42c.6-.45 1-1.16 1-1.97v-2C22.9 3.1 21.8 2 20.45 2M2.9 4.45c0-.3.25-.55.55-.55h17c.3 0 .55.25.55.55v2c0 .3-.25.55-.55.55h-17c-.3 0-.55-.25-.55-.55zm6 4.45H15v2.05s0 .03-.01.04-.02.01-.04.01h-6s-.03 0-.04-.01c0 0-.01-.02-.01-.04zm10.79 10.79c-.2.2-.46.31-.74.31h-14c-.28 0-.55-.11-.74-.31-.2-.2-.31-.46-.31-.74V8.9H7v2.05c0 .52.21 1.01.57 1.38.37.37.86.57 1.38.57h6c.52 0 1.01-.21 1.38-.57s.57-.86.57-1.38V8.9H20v10.05c0 .28-.11.55-.31.74"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ArchiveIcon = makeIcon('ArchiveIcon', ArchiveIconSvg)
